import { useState } from 'react';
import { MessageCircle, Copy, Check } from 'lucide-react';

/**
 * WhatsAppPanel — shows a pre-written WhatsApp message for the client
 * when a file is in "Awaiting Signature" status. Supports English and Afrikaans.
 */
export default function WhatsAppPanel({ clientName, language }) {
  const [copied, setCopied] = useState(false);

  const message = (language || 'English') === 'Afrikaans'
    ? `Hallo ${clientName}, dit is Wouter van Optimum PFP. Marinus het my gevra om jou gou in kennis te stel \u2014 ek het sopas dokumente (via QuicklySign) na jou gestuur vir jou oorsig en handtekening. Hou asseblief jou "inbox" dop, dit behoort binnekort daar te wees. Skakel ons gerus as jy enige vrae het of as iets onduidelik is. Groete`
    : `Hi ${clientName}, it\u2019s Wouter from Optimum PFP. Marinus asked me to give you a quick heads-up \u2014 I\u2019ve just sent you some documents via QuicklySign that need your review and signature. Please keep an eye on your inbox, it should be there any moment. Give us a call if you have any questions or if anything looks unclear. Regards`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(message);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback for older browsers
      const ta = document.createElement('textarea');
      ta.value = message;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div style={waStyles.card}>
      <div style={waStyles.header}>
        <MessageCircle size={16} />
        <span>WhatsApp Message</span>
      </div>
      <div style={waStyles.body}>
        <textarea
          readOnly
          value={message}
          style={waStyles.textarea}
          rows={6}
        />
        <button onClick={handleCopy} style={waStyles.copyBtn}>
          {copied ? <Check size={16} /> : <Copy size={16} />}
          {copied ? 'Copied!' : 'Copy Message'}
        </button>
      </div>
    </div>
  );
}

const waStyles = {
  card: {
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid var(--cp-surface-alt)',
    boxShadow: '0 2px 8px rgba(15, 76, 117, 0.06)',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.4rem',
    padding: '0.65rem 1rem',
    background: '#25D366',
    color: 'var(--cp-surface)',
    fontSize: '0.85rem',
    fontWeight: 600,
  },
  body: {
    padding: '0.85rem 1rem',
    background: 'var(--cp-surface)',
  },
  textarea: {
    width: '100%',
    padding: '0.6rem 0.75rem',
    border: '1.5px solid var(--cp-border)',
    borderRadius: '8px',
    fontSize: '0.82rem',
    lineHeight: 1.5,
    color: 'var(--cp-text)',
    resize: 'none',
    background: '#F7F9FC',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
  },
  copyBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.4rem',
    marginTop: '0.6rem',
    padding: '0.5rem 1rem',
    background: '#25D366',
    color: 'var(--cp-surface)',
    border: 'none',
    borderRadius: '8px',
    fontSize: '0.85rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s',
    width: '100%',
    justifyContent: 'center',
  },
};
